<template>
  <v-sheet tile class="slide-container">
    <v-row>
      <v-col>
        <v-row class="justify-center justify-sm-start">
          <div class="v-btn-toggle dates-toggler ">
            <v-btn @click="dateSubtract" class="toggler"
                   depressed
                   outlined>
              <v-icon color="primary">chevron_left</v-icon>
            </v-btn>
            <v-btn class="date-btn"
                   depressed
                   outlined
                   readonly
            >
              <span class="font-weight-bold">{{selectedDate}}</span>
            </v-btn>
            <v-btn class="toggler"
              @click="dateAdd"
              depressed
              outlined
            >
              <v-icon color="primary">chevron_right</v-icon>
            </v-btn>
          </div>
        </v-row>
      </v-col>
      <v-col class="text-right hidden-xs-only">
        <v-btn-toggle @change="changeDateMode" mandatory v-model="slider" background-color="#EEF3F9">
          <v-btn v-for="mode in mods" :key="mode"
                 :ref="mode"
                 :value="mode"
                 active-class="selected"
                 depressed
                 outlined
          >
            {{mode}}
          </v-btn>
        </v-btn-toggle>
      </v-col>

    </v-row>


    <v-overlay v-model="overlay"></v-overlay>
  </v-sheet>
</template>

<script>
  const moment = require('moment-timezone')
  moment.locale('en', {
    week: {
      dow: 1
    }
  });

  export default {
    name: "DashboardTimeSlider",
    mounted() {
    },
    computed: {
      selectedDate() {
        let dates = this.date
        let currentWeek = moment(dates[0]).utc()
          .isSame(moment().utc()
            .startOf('week'), 'day') && moment(dates[1]).utc()
          .isSame(moment().utc()
            .endOf('week'), 'day')
        let nextWeek = moment(dates[0]).utc()
          .isSame(moment().utc().add(1, 'week')
            .startOf('week'), 'day') && moment(dates[1]).utc()
          .isSame(moment().utc().add(1, 'week')
            .endOf('week'), 'day')
        let lastWeek = moment(dates[0]).utc()
          .isSame(moment().utc().subtract(1, 'week')
            .startOf('week'), 'day') && moment(dates[1]).utc()
          .isSame(moment().utc().subtract(1, 'week')
            .endOf('week'), 'day')
        let currentMonth = moment(dates[0]).utc()
          .isSame(moment().utc()
            .startOf('month'), 'day') && moment(dates[1]).utc()
          .isSame(moment().utc()
            .endOf('month'), 'day')
        let nextMonth = moment(dates[0]).utc()
          .isSame(moment().utc().add(1, 'month')
            .startOf('month'), 'day') && moment(dates[1]).utc()
          .isSame(moment().utc().add(1, 'month')
            .endOf('month'), 'day')
        let lastMonth = moment(dates[0]).utc()
          .isSame(moment().utc().subtract(1, 'month')
            .startOf('month'), 'day') && moment(dates[1]).utc()
          .isSame(moment().utc().subtract(1, 'month')
            .endOf('month'), 'day')
        let currentYear = moment(dates[0]).utc()
          .isSame(moment().utc()
            .startOf('year'), 'day') && moment(dates[1]).utc()
          .isSame(moment().utc()
            .endOf('year'), 'day')
        let nextYear = moment(dates[0]).utc()
          .isSame(moment().utc().add(1, 'year')
            .startOf('year'), 'day') && moment(dates[1]).utc()
          .isSame(moment().utc().add(1, 'year')
            .endOf('year'), 'day')
        let lastYear = moment(dates[0]).utc()
          .isSame(moment().utc().subtract(1, 'year')
            .startOf('year'), 'day') && moment(dates[1]).utc()
          .isSame(moment().utc().subtract(1, 'year')
            .endOf('year'), 'day')


        let calendar_obj = {
          sameDay: 'MMM Do YYYY [(Today)]',
          nextDay: 'MMM Do YYYY [(Tomorrow)]',
          nextWeek: 'MMM Do YYYY',
          lastDay: 'MMM Do YYYY [(Yesterday)]',
          lastWeek: 'MMM Do YYYY',
          sameElse: 'MMM Do YYYY'
        }


        if (dates[0].isSame(dates[1], 'day')) {
          return moment(dates[0]).calendar(calendar_obj)
        } else {
          if (currentWeek) {
            return 'Current Week'
          }
          if (nextWeek) {
            return 'Next Week'
          }
          if (lastWeek) {
            return 'Last Week'
          }
          if (currentMonth) {
            return 'Current Month'
          }
          if (nextMonth) {
            return 'Next Month'
          }
          if (lastMonth) {
            return 'Last Month'
          }
          if (currentYear) {
            return 'Current Year'
          }
          if (nextYear) {
            return 'Next Year'
          }
          if (lastYear) {
            return 'Last Year'
          }


          let combined_date = dates.map(item => moment(item).calendar(calendar_obj)).join(' ~ ')
          return combined_date

        }
      }
    },
    methods: {
      dateAdd() {
        this.date = [moment(this.date[0]).add(1, this.slider).startOf(this.slider), moment(this.date[1]).add(1, this.slider).endOf(this.slider)]
        this.$emit('mode_changed', {
          mode: this.slider,
          data_range: [this.date[0], this.date[1]],
          formatted_date: this.selectedDate
        })

      },
      dateSubtract() {
        this.date = [moment(this.date[0]).subtract(1, this.slider).startOf(this.slider), moment(this.date[1]).subtract(1, this.slider).endOf(this.slider)]
        this.$emit('mode_changed', {
          mode: this.slider,
          data_range: [this.date[0], this.date[1]],
          formatted_date: this.selectedDate
        })
      },
      customClickWatcher() {
        const custom = this.$refs['Custom'][0].$el
        custom.addEventListener('click', this.changeDateMode, false);
      },
      applyCustomDataRange() {
        this.$emit('mode_changed', {
          mode: this.slider, data_range: [this.date[0], this.date[1]],
          formatted_date: this.selectedDate
        })
        this.dialog = false
        this.overlay = false
        this.date[0] = ''
        this.date[1] = ''
      },

      saveDate(source, date) {
        this.$refs[source].save(date)

      },
      pickerValue(date) {
        return moment(date).format('YYYY MM DD')
      },

      closeCustomRange() {
        this.dialog = false
        this.overlay = false
        this.slider = 0
        this.changeDateMode();
        this.date = []
      },
      changeDateMode(mode) {

        this.date = [moment().utc().startOf(mode), moment().utc().endOf(mode)]
        this.$emit('mode_changed', {
          mode: this.slider,
          data_range: [this.date[0], this.date[1]],

          formatted_date: this.selectedDate
        })

      }
    },
    data: () => ({
      compare_date_first: false,
      compare_date_second: false,
      date: [moment(), moment()],
      dialog: false,
      overlay: false,
      slider: 'Day',
      mods: ['Day', 'Week', 'Month', 'Year']
    })
  }
</script>

<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';

  .toggler {
    min-width: 24px !important;
    padding: 0 !important;
  }

  .slide-container {
    background-color: #EEF3F9;
    padding: 0 4rem;
    position: fixed;
    width: 100vw;
    z-index: 1;
    margin: -20px;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      padding: 0 2rem;
    }
    @media #{map-get($display-breakpoints, 'xs-only')} {
      padding: 0;
    }

    .v-btn-toggle {
      .v-btn {
        max-height: 36px !important;
        font-weight: 400 !important;
        color: #3565BA;
        text-transform: none !important;

        &.date-btn {
          font-size: .8rem;
          padding: 0 1rem;
        }

        &.selected {
          background-color: #3565BA !important;
          color: white !important;
        }

        &.selected_date {
          background-color: #EEF3F9 !important;
          color: #3565BA !important;
        }
      }

      &.dates-toggler {
        float: right;


      }


    }
  }
</style>




// WEBPACK FOOTER //
// src/Elements/DashboardTimeSlider.vue